import React from 'react';
import { Dialog, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { documentViewerModalStyles } from './DocumentViewerModal.styles';
import { useTranslation } from "react-i18next";

interface DocumentViewerModalProps {
  open: boolean;
  onClose: () => void;
  imageSrc: string | null;
  onVerify: () => void;
}

export function DocumentViewerModal({ open, onClose, imageSrc, onVerify }: DocumentViewerModalProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullScreen PaperProps={{ sx: documentViewerModalStyles.paper }} >
      <Box sx={documentViewerModalStyles.root}>
        <IconButton onClick={onClose} sx={documentViewerModalStyles.closeButton}>
          <CloseIcon sx={documentViewerModalStyles.closeIcon} />
        </IconButton>

        <Box sx={documentViewerModalStyles.imageContainer}>
          {imageSrc && ( <img src={imageSrc} alt={t("document_image", { defaultValue: "Document Image" })} style={documentViewerModalStyles.image} /> )}
        </Box>

        <Box sx={documentViewerModalStyles.verifyWrap}>
          <Box onClick={onVerify} sx={documentViewerModalStyles.verifyButton}>
            <Typography sx={documentViewerModalStyles.verifyText}>
              {t("verify", { defaultValue: "Verify" })}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}